<template>
  <div class="container">
    <div class="unauth-401">
      <h1>401</h1>
      <h3>{{ $t('unauth.line1') }}</h3>
      <h3>{{ $t('unauth.line2') }}</h3>
      <h3>{{ $t('unauth.line3') }}</h3>
    </div>
    <div class="image">
      <img src="@/assets/image/woman-standing.png" width="160" height="177" alt="woman-standing">
    </div>
    <a class="customer-service" :href="customerServiceLink" target="_blank">{{ $t('contactCustomerService') }}</a>
  </div>
</template>
<script>
import semverGte from 'semver/functions/gte'

export default {
  name: 'UnauthPage',
  data() {
    return {
      csLinkMap: {
        'zh-CN': process.env.VUE_APP_LIVECAHT_CN,
        'zh-TW': process.env.VUE_APP_LIVECAHT_TW,
        'en-US': process.env.VUE_APP_LIVECAHT_EN,
      }
    }
  },
  computed: {
    customerServiceLink() {
      let link = this.csLinkMap[this.$i18n.locale] ?? ''
      if (!link) return ''  
      try {
        const sdkVersion = new URLSearchParams(location.search).get('sdkVersion')
        const prefix = (sdkVersion && semverGte(sdkVersion, '1.2.0')) ? 'browser:' : ''
        return prefix + link
      }
      catch (e) {
        console.error('Resolve customer service link error', e.message)
        return link
      }
    },
  }
}
</script>
<style lang="scss">
.unauth-401 {
  flex: 1 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  letter-spacing: 0.84px;

  h1 {
    color: var(--primary-clicked, #FAAD14);
    text-align: left;
    font-family: system-ui;
    font-size: 56px;
    font-style: normal;
    font-weight: 900;
    line-height: 64px; /* 114.286% */
  }
  h3 {
    font-family: ui-monospace;
  }
}
.image {
  flex: 1 100%;
  text-align: center;
}
.customer-service {
  display: flex;
  padding: 16px;
  font-size: 16px;
  line-height: 24px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-radius: 888px;
  background: var(--primary-color-golden-sunshine-05, #FFE553);
  color: #262626;
  width: 100%;
  height: fit-content;
}
.container {
  margin: auto;
  padding: 16px 32px 32px 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 396px;
  height: 453px;
  gap: 15px;
  background: white;
  border-radius: 16px;
}
</style>